export const oauthUrl = {
    prod: 'https://oauth.tessell.com',
    dev: 'https://oauth.tsl-terls.cloud',
};

// Array is in order of priority of cost effectiveness
export const costEffectiveRegions = ['ap-south-1', 'centralIndia'];
